var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrafterTagUnchecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.609375 12.2772L0.803818 14.0039L2.06381 12.8061L4.21824 6.89503C3.68935 6.76281 3.22269 6.49837 2.84158 6.13281L0.609375 12.2772Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15009 6.13281C6.76899 6.49837 6.29454 6.76281 5.77344 6.89503L7.92787 12.8061L9.18786 14.0039L9.39008 12.2772L7.15009 6.13281Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28403 4.35553C7.51736 3.1422 6.81737 2.06887 5.77515 1.69554V0.777772C5.77515 0.349998 5.42515 0 4.99738 0C4.56961 0 4.21961 0.349998 4.21961 0.777772V1.69554C3.31739 2.02221 2.66406 2.87776 2.66406 3.88886C2.66406 5.31996 3.95517 6.45551 5.43293 6.18329C6.3507 6.01218 7.10514 5.2733 7.28403 4.35553ZM4.99738 4.66664C4.56961 4.66664 4.21961 4.31664 4.21961 3.88886C4.21961 3.46109 4.56961 3.11109 4.99738 3.11109C5.42515 3.11109 5.77515 3.46109 5.77515 3.88886C5.77515 4.31664 5.42515 4.66664 4.99738 4.66664Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrafterTagUnchecked);
export default __webpack_public_path__ + "static/media/drafter_tag_unchecked.0abb2542.svg";
export { ForwardRef as ReactComponent };